import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "mail",
  "use": "mail-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"mail\">\n  <circle cx=\"24\" cy=\"24\" r=\"24\" />\n  <path transform=\"translate(16 18)\" fill=\"#FFF\" d=\"M8.68 7.897L16.742.464c.18-.154.052-.464-.18-.464H.438a.268.268 0 0 0-.18.464L8.32 7.923a.276.276 0 0 0 .36-.026\" />\n  <path fill=\"#FFF\" d=\"M15 19.247v10.506c0 .226.274.326.423.175l5.502-5.39c.1-.1.1-.276 0-.376l-5.502-5.09c-.174-.15-.423-.05-.423.175m19 10.487V19.247c0-.226-.25-.326-.425-.176l-5.5 5.082c-.1.1-.1.275 0 .375l5.5 5.406c.15.15.425.025.425-.2\" />\n  <path transform=\"translate(16 25)\" fill=\"#FFF\" d=\"M.36 6h16.305c.232 0 .36-.275.18-.425L11.153.15a.254.254 0 0 0-.36 0L8.68 2.025c-.103.1-.257.1-.36 0L6.233.15a.254.254 0 0 0-.36 0L.18 5.575C0 5.725.13 6 .36 6\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/mail.svg
// module id = 444
// module chunks = 0